import { AdminApprovalreq, AssignVendor, CommonResponseModel, DatesReqDto, DriverUpdateReq, TripReq, VehicleIdReq, VehicleReqId, VehicleRequest, VehicleTypeReq, roleReq } from "@project-management-system/shared-models";
import { CommonAxiosService } from "packages/libs/shared-services/src/common-axios-service-prs";
import { VehicleReqDto } from "packages/libs/shared-models/src/common/vms/vehicle-req/vehicle-req-dto";
import { vehicleReportReq } from "../../../../../../../../packages/libs/shared-models/src/common/vms/vehicle-req/vehicle-report-req"
export class VehicleReqService extends CommonAxiosService {

    private URL = "/vehicle_req";

    async getAllDetailByVehicelId(req: any): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getAllDetailByVehicelId', req)
    }

    async createVehiclerequest(req: VehicleReqDto): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/createVehiclerequest', req)
    }
    async getAllVehiclerequest(req?: VehicleRequest): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getAllVehiclerequest', req)
    }

    async getAllDeptWiseVehcieReq(req: roleReq): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getAllDeptWiseVehcieReq', req)
    }
    async updateHodApproval(req: VehicleIdReq): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/updateHodApproval', req)
    }

    async updateHODRejection(req: VehicleIdReq): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/updateHODRejection', req)
    }

    async getVehicleRequestApprove(): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getVehicleRequestApprove')
    }

    async getAdminApproval(req?: VehicleRequest): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getAdminApproval', req)
    }
    async updateAdminApproveData(req: AdminApprovalreq): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/updateAdminApproveData', req)
    }

    async assignRequestToVendor(req: AssignVendor): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/assignRequestToVendor', req)
    }

    async getAllVendorDetails(req: roleReq): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getAllVendorDetails', req)
    }

    async updateVendorVehicelAssin(req: AdminApprovalreq): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/updateVendorVehicelAssin', req)
    }

    async updateVendorVehicelDriverAssin(req: AdminApprovalreq): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/updateVendorVehicelDriverAssin', req)
    }

    async rejectVehicleReq(req: VehicleIdReq): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/rejectVehicleReq', req)
    }

    async getvehicledropdown(req?: VehicleRequest): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getvehicledropdown', req)
    }

    async getAdmindropdown(req?: VehicleRequest): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getAdmindropdown', req)
    }

    async getHoddropdown(req?: VehicleRequest): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getHoddropdown', req)
    }

    async getVehicleReqReportData(req?: vehicleReportReq): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getVehicleReqReportData', req)
    }
    async getAssignedVehicleDetails(req:VehicleTypeReq): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getAssignedVehicleDetails',req)
    }

    async getVehicleReportData(req?: vehicleReportReq): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getVehicleReportData', req)
    }

    async updateTripDetails(req: TripReq): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/updateTripDetails', req)
    }

    async createTripDetails(req: TripReq): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/createTripDetails', req)
    }
    async getAssignedVehicles(): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getAssignedVehicles')
    }

    async getAssignedVehiclesByVehicleType(req:VehicleTypeReq): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getAssignedVehiclesByVehicleType',req)
    }

    async getVehicleReqStatusCount(): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getVehicleReqStatusCount')
    }

    async getTotalVehiclesCount(): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getTotalVehiclesCount')
    }

    async getVehicleSummary(req: DatesReqDto): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getVehicleSummary', req)
    }

    async getVehicleRenwalsData(): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getVehicleRenwalsData')
    }

    async getBudgetVSExpenditure(req: DatesReqDto): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getBudgetVSExpenditure', req)
    }

    async getMonthsBetweenDates(): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getMonthsBetweenDates')
    }

    async getDatesInMonth(): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getDatesInMonth')
    }
    async getVehicleAvaialbleVSOccupied(req?: DatesReqDto): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getVehicleAvaialbleVSOccupied', req)
    }

    async getVehicleIssueStatus(): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getVehicleIssueStatus')
    }

    async getTop5VehicleIssues(): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getTop5VehicleIssues')
    }

    async getTop5RenwalVehicles(): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getTop5RenwalVehicles')
    }

    async getTop5ServiceInprogress(): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getTop5ServiceInprogress')
    }

    async getVendorsInfo(req?: DatesReqDto): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getVendorsInfo', req)
    }

    async RejectionsData(req?: DatesReqDto): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/RejectionsData', req)
    }

    async getServicePendingAge(): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getServicePendingAge')
    }

    async updateAdminRejection(req: VehicleIdReq): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/updateAdminRejection', req)
    }
    // getAllVehicleRequest(req: VehicleRequest) {
    //     throw new Error("Method not implemented.");
    //   }
    //   getVehicleDropdown() {
    //     throw new Error("Method not implemented.");
    //   }

    async getDepartmentWiseStatus(): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getDepartmentWiseStatus',)
    }

    async getTop5TripDetailsOfDept(req: DatesReqDto): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getTop5TripDetailsOfDept', req)
    }

    async getRequestRateAndPendingApprovals(req: DatesReqDto): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getRequestRateAndPendingApprovals', req)
    }

    async getBudgetVSExpenditureDeptWise(): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getBudgetVSExpenditureDeptWise')
    }

    async getScheduledTripsOnMonth(req: DatesReqDto): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getScheduledTripsOnMonth', req)
    }

    async getVehicleDetailsByReqId(req:VehicleReqId): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getVehicleDetailsByReqId', req)
    }
    async getAllDetailsToUpdateDriver(req:DriverUpdateReq): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getAllDetailsToUpdateDriver', req)
    }
    async getAllDriversToUpdate(req:DriverUpdateReq): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getAllDriversToUpdate', req)
    }
    async updateDriver(req:DriverUpdateReq): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/updateDriver', req)
    }
    
}